var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "sidebar-link-group sidebar-link" },
    [
      _c(
        "a",
        {
          staticClass: "sidebar-link__router-link",
          class: _vm.classObject,
          attrs: { href: "#", target: "_self" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              $event.preventDefault()
              return _vm.toggleMenuItem()
            },
          },
        },
        [
          _vm._t("title"),
          _c("i", { staticClass: "expand-icon fa fa-angle-down" }),
        ],
        2
      ),
      _c("expanding", [
        _c(
          "ul",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: this.expanded,
                expression: "this.expanded",
              },
            ],
            ref: "linkGroupWrapper",
            staticClass: "sidebar-submenu in",
          },
          [_vm._t("default")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }